/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './DeepSeaSelect.css';

const info=[
  '推荐',
  '好感',
  '中立',
  '差评',
  '反感'
]

let btn=[
  {
    class: '总值',
    type: 'all'
  }, {
    class: '微信',
    type: 'wx'
  }, {
    class: '微博',
    type: 'wb'
  }, {
    class: '知乎',
    type: 'zh'
  }, {
    class: '今日头条',
    type: 'tt'
  },{
    class: '今日头条-头条',
    type: 'tt-tt'
  },{
    class: '今日头条-悟空',
    type: 'tt-wk'
  }
]

let hasNewsList = [
  {
    class: '新闻',
    type: 'news'
  },{
    class: '百家号',
    type: 'hundred_homes'
  }
]

class DeepSeaSelect extends React.Component {
  constructor(props){
    super(props);

    this.state={
      active:'all'
    };
  }

  sum (arr) {
    return arr.reduce((prev,curr,idx,arr)=>{
      return prev+curr
    })
  }



  render() {
    const {json, hasNewsState}=this.props  
    const {active}=this.state
    let list = btn;

    if(hasNewsState) {
      list = btn.concat(hasNewsList);
    }

    return (
      <div className={s.root}>
        <select onChange={(e)=>this.setState({active:e.target.value})} value={active}>
          { list.map(item => <option key={item.type} value={item.type}>{item.class}</option>) }
        </select>

        {this.props.json[active].map((i,index)=>
          <span className={s.option} key={index}>{info[index]} : {i}</span>    
        )}
        <span className={s.option}>总数 : {this.sum(json[active])}</span>
      </div>
    )
  }
}

export default withStyles(s)(DeepSeaSelect);



// WEBPACK FOOTER //
// src/components/DeepSeaSelect/DeepSeaSelect.js